import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { Process } from './process.model';

export const upsertProcess = createAction(
  '[Process/API] Upsert Process',
  props<{ process: Process }>()
);

export const deleteProcess = createAction(
  '[Process/API] Delete Process',
  props<{ id: string }>()
);

export const clearProcess = createAction(
  '[Process/API] Clear Process'
);
